import React, { useState } from "react";
import Header from "../../components/Header";
import "../../styles/custom.css";
import { Typography } from "@mui/material";
import API_BASE_URL from "../../config";

function ResetPassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState("");
  const [type, setType] = useState(""); // success or error
  const [loading, setLoading] = useState(false);

  const toggleOld = () => setShowOld(!showOld);
  const toggleNew = () => setShowNew(!showNew);
  const toggleConfirm = () => setShowConfirm(!showConfirm);

  const handleReset = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
  setType("error");
  setMessage("All fields are required.");
  return;
}

if (newPassword === oldPassword) {
  setType("error");
  setMessage("New password cannot be the same as old password.");
  return;
}

if (newPassword.length < 8 || !/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
  setType("error");
  setMessage("New password must be at least 8 characters and include a special character.");
  return;
}

if (newPassword !== confirmPassword) {
  setType("error");
  setMessage("New password and confirm password do not match.");
  return;
}


    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/auth/reset_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // needed for session-based auth
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
        }),
      });

      const data = await response.json();
      if (data.status === "success") {
        setType("success");
        setMessage("Password updated successfully!");
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setType("error");
        setMessage(data.message || "Something went wrong");
      }
    } catch (err) {
      setType("error");
      setMessage("Error connecting to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="container mt-5 col-md-6">
        <Typography variant="h5" className="mb-4 font-weight-bold">
          Reset Password
        </Typography>

        <form onSubmit={handleReset} className="w-100">
          {/* Old Password */}
          <div className="form-group mb-4 position-relative">
            <label className="custom-label">Old Password <span className="text-danger">*</span></label>
            <input
              type={showOld ? "text" : "password"}
              className="form-control custom-input pr-5"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              placeholder="Enter your old password"
            />
            <i
              className={`far ${showOld ? "fa-eye-slash" : "fa-eye"} text-danger`}
              onClick={toggleOld}
              style={{
                position: "absolute",
                top: "38px",
                right: "15px",
                cursor: "pointer",
              }}
            />
          </div>

          {/* New Password */}
          <div className="form-group mb-4 position-relative">
            <label className="custom-label">New Password <span className="text-danger">*</span></label>
            <input
              type={showNew ? "text" : "password"}
              className="form-control custom-input pr-5"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="Enter your new password"
            />
            <i
              className={`far ${showNew ? "fa-eye-slash" : "fa-eye"} text-danger`}
              onClick={toggleNew}
              style={{
                position: "absolute",
                top: "38px",
                right: "15px",
                cursor: "pointer",
              }}
            />
          </div>

          {/* Confirm Password */}
          <div className="form-group mb-4 position-relative">
            <label className="custom-label">Confirm New Password <span className="text-danger">*</span></label>
            <input
              type={showConfirm ? "text" : "password"}
              className="form-control custom-input pr-5"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="Re-enter your new password"
            />
            <i
              className={`far ${showConfirm ? "fa-eye-slash" : "fa-eye"} text-danger`}
              onClick={toggleConfirm}
              style={{
                position: "absolute",
                top: "38px",
                right: "15px",
                cursor: "pointer",
              }}
            />
          </div>

          {/* Message */}
          {message && (
            <div className={`alert alert-${type === "error" ? "danger" : "success"} small py-2 mb-3`} role="alert">
              {message}
            </div>
          )}

          {/* Submit */}
          <button type="submit" className="btn btn-primary w-100 font-weight-bold" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </>
  );
}

export default ResetPassword;
